(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("examQuestion", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/exams/examQuestionView.html",
            controller: ["examQuestionResource", "examQuestionFilesResource", "frameworkService", "$uibModal", "$scope", "$rootScope", "$timeout", "$state", "$stateParams", "$translate", "_", "Upload", "messageService", ExamQuestionCtrl],
            controllerAs: "vm"
        };
        function ExamQuestionCtrl(examQuestionResource, examQuestionFilesResource, frameworkService, $uibModal, $scope, $rootScope, $timeout, $state, $stateParams, $translate, _, Upload, messageService) {
            var vm = this;
            vm.loading = true;
            vm.hasQuestionHeader = false;
            vm.hasQuestionHeaderImage = false;
            vm.hasReferenceDocuments = false;
            vm.noneSelected = true;
            vm.number = $stateParams.number;
            vm.questionPlaceholder = "exams.examQuestionForm.questionPlaceholder";
            if ($state.current.name === "main.learningItems.addExamQuestion") {
                vm.state = "Add";
                vm.questionNumber = "0";
                vm.categoryNumber = "0";
                vm.pageTitle = "menu.learningItems.addExamQuestion";
            }
            else if ($state.current.name === "main.learningItems.addExamCategoryQuestion") {
                vm.state = "Add";
                vm.questionNumber = "0";
                vm.categoryNumber = $stateParams.categoryNumber;
                vm.pageTitle = "menu.learningItems.addExamQuestion";
            }
            else {
                vm.state = "Edit";
                vm.questionNumber = $stateParams.questionNumber;
                vm.pageTitle = "menu.learningItems.editExamQuestion";
                if ($stateParams.categoryNumber)
                    vm.categoryNumber = $stateParams.categoryNumber;
                else
                    vm.categoryNumber = "0";
            }
            vm.questionTypes = [
                { id: 1, name: "exams.questionType.multipleChoice" },
                { id: 2, name: "exams.questionType.longAnswer" },
                { id: 3, name: "exams.questionType.fileUpload" }
            ];
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceOptions = { resize: true, height: 200, plugins: "code, paste, image", language: lang, paste_data_images: true };
            vm.tinymceInlineOptions = {
                menubar: false,
                resize: true,
                inline: true,
                plugins: "code, paste, textcolor, autoresize",
                toolbar: "bold italic underline strikethrough superscript subscript | forecolor backcolor | undo bullist numlist",
                forced_root_block: false,
                language: lang,
                setup: function (editor) {
                    editor.on("init", function () {
                        // Default classes of tinyMCE are a bit weird
                        // I add my own class on init
                        // this also sets the empty class on the editor on init
                        if (editor.getContent() === "")
                            window.tinymce.DOM.addClass(editor.bodyElement, "content-editor empty");
                        else
                            window.tinymce.DOM.addClass(editor.bodyElement, "content-editor");
                    });
                    editor.on("focus", function () {
                        window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                    });
                    editor.on("blur", function () {
                        if (editor.getContent() === "") {
                            window.tinymce.DOM.addClass(editor.bodyElement, "empty");
                        }
                        else {
                            window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                        }
                    });
                }
            };
            vm.tinymceInlineOptionsFeedback = angular.copy(vm.tinymceInlineOptions);
            vm.tinymceInlineOptionsFeedback.toolbar = "bold italic | forecolor backcolor | undo bullist numlist styleselect";
            vm.sortableOptions = {
                handle: ".fa-bars",
                disabled: vm.state === "Add",
                axis: "y",
                stop: function () {
                    vm.updateOrder();
                }
            };
            vm.updateOrder = function () {
                var order = 0;
                _.each(vm.model.question.examQuestionAnswers, function (answer) {
                    order++;
                    answer.order = order;
                });
            };
            vm.changeQuestionType = function () {
                if (vm.model.question.questionTypeId === 1)
                    vm.questionPlaceholder = "exams.examQuestionForm.questionPlaceholder";
                else
                    vm.questionPlaceholder = "";
            };
            examQuestionResource.getExamQuestionViewModel({ number: vm.number, questionNumber: vm.questionNumber }, function (model) {
                vm.model = model;
                vm.hasQuestionHeader = !!vm.model.questionHeader;
                vm.hasQuestionHeaderImage = !!vm.model.questionHeaderImageUrl;
                vm.hasReferenceDocuments = vm.model.questionFiles !== null && vm.model.questionFiles.length > 0;
                if (vm.state === "Add") {
                    vm.readOnly = false;
                    vm.model.question = {
                        question: "",
                        feedback: ""
                    };
                    vm.model.question.examId = vm.model.examId;
                    vm.model.question.examCategoryId = "0";
                    vm.model.question.questionTypeId = 1;
                    vm.model.question.points = 1;
                    vm.model.question.statusId = 0;
                    vm.model.question.editable = true;
                    vm.model.question.examQuestionAnswers = [
                        { order: 1, correct: false, answer: "", feedback: "", randomOrder: false, enabled: true, editable: true },
                        { order: 2, correct: false, answer: "", feedback: "", randomOrder: false, enabled: true, editable: true },
                        { order: 3, correct: false, answer: "", feedback: "", randomOrder: false, enabled: true, editable: true },
                        { order: 4, correct: false, answer: "", feedback: "", randomOrder: false, enabled: true, editable: true }
                    ];
                    if (vm.categoryNumber !== "0") {
                        var category = _.find(vm.model.examCategories, { number: parseInt(vm.categoryNumber) });
                        if (category)
                            vm.model.question.examCategoryId = category.id.toString();
                        else
                            messageService.error("common.genericError");
                    }
                }
                else {
                    vm.readOnly = model.question.readOnly && !model.allowEditingReadOnly;
                    vm.model.question.examCategoryId = vm.model.question.examCategoryId.toString();
                    vm.noneSelected = vm.checkNoneSelected();
                    vm.updateMultipleCorrect();
                }
                vm.model.question.deletedExamQuestionAnswers = [];
                vm.loading = false;
            });
            vm.addAnswer = function () {
                var order = _.max(_.pluck(vm.model.question.examQuestionAnswers, "order")) + 1;
                var newAnswer = { order: order, correct: false, answer: "", feedback: "", randomOrder: false, enabled: true, editable: true };
                vm.model.question.examQuestionAnswers.push(newAnswer);
                vm.showErrors = false;
            };
            vm.answerChanged = function () {
                vm.noneSelected = vm.checkNoneSelected();
                vm.updateMultipleCorrect();
            };
            vm.updateMultipleCorrect = function () {
                vm.multipleCorrect = _.where(vm.model.question.examQuestionAnswers, { correct: true }).length > 1;
            };
            vm.checkNoneSelected = function () {
                var result = _.every(vm.model.question.examQuestionAnswers, { correct: false });
                return result;
            };
            vm.removeAnswer = function (answerChoice) {
                //IF SAVED TO DB ALREADY, ADD TO DELETED LIST
                if (answerChoice.id)
                    vm.model.question.deletedExamQuestionAnswers.push(answerChoice);
                vm.model.question.examQuestionAnswers = angular.copy(_.without(vm.model.question.examQuestionAnswers, answerChoice));
                //var index = vm.model.question.examQuestionAnswers.indexOf(answerChoice);
                //vm.model.question.examQuestionAnswers.splice(index, 1)
                //vm.model.question.examQuestionAnswers = angular.copy(vm.model.question.examQuestionAnswers);
                vm.updateOrder();
                vm.noneSelected = vm.checkNoneSelected();
                vm.updateMultipleCorrect();
            };
            vm.saveQuestion = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    if (vm.state === "Add") {
                        if (vm.model.question.questionTypeId !== 1)
                            vm.model.question.examQuestionAnswers = [];
                        examQuestionResource.save({ number: vm.number }, vm.model.question, function (result) {
                            var questionNumber = result.question.number;
                            messageService.success("exams.examQuestionForm.questionSaved");
                            if ($stateParams.categoryNumber)
                                $state.go("main.learningItems.editExamCategoryQuestion", { number: vm.number, categoryNumber: vm.categoryNumber, questionNumber: questionNumber });
                            else
                                $state.go("main.learningItems.editExamQuestion", { number: vm.number, questionNumber: questionNumber });
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                    else {
                        examQuestionResource.update({ number: vm.number, questionNumber: vm.questionNumber }, vm.model.question, function () {
                            messageService.success("exams.examQuestionForm.questionSaved");
                            if ($stateParams.categoryNumber)
                                $state.go("main.learningItems.manageExamCategoryQuestions", { number: vm.number, categoryNumber: vm.categoryNumber });
                            else
                                $state.go("main.learningItems.manageExamQuestions", { number: vm.number });
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.copyQuestion = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                examQuestionResource.copy({ number: vm.number, questionNumber: vm.questionNumber }, {}, function (result) {
                    var questionNumber = result.question.number;
                    messageService.success("exams.examQuestionForm.questionCopied");
                    $state.go($state.current, { number: vm.number, questionNumber: questionNumber });
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            };
            //Clears form to be able to add another
            vm.saveAndAddNew = function () {
                if (vm.form.$valid) {
                    vm.saving = true;
                    if (vm.model.question.questionTypeId !== 1)
                        vm.model.question.examQuestionAnswers = [];
                    examQuestionResource.save({ number: vm.number }, vm.model.question, function () {
                        vm.saving = false;
                        messageService.success("exams.examQuestionForm.questionSaved");
                        $state.go($state.current, { number: vm.number }, { reload: true });
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.cancel = function () {
                if ($stateParams.categoryNumber)
                    $state.go("main.learningItems.manageExamCategoryQuestions", { number: vm.number, categoryNumber: vm.categoryNumber });
                else
                    $state.go("main.learningItems.manageExamQuestions", { number: vm.number });
            };
            vm.saveQuestionHeader = function () {
                var data = JSON.stringify(vm.model.questionHeader);
                examQuestionResource.saveExamQuestionHeader({ number: vm.number, questionNumber: vm.questionNumber }, data, function () {
                    messageService.success("exams.examQuestionForm.questionSaved");
                    vm.hasQuestionHeader = !!vm.model.questionHeader; // !! because want true/false not questionHeader's text
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.paste = function () {
                if (vm.state === "Edit")
                    return;
                $timeout(function () {
                    // check if text has a double linefeed (question and answers separated but an empty line)
                    if (vm.model.question.question.indexOf("\n\n") > -1) {
                        var splits = vm.model.question.question.split("\n\n");
                        //answers are the last split - we need at least 2 answers for the data to be valid
                        var answers = splits.pop().split("\n");
                        if (answers.length >= 2) {
                            var newAnswers = [];
                            var order = 0;
                            _.each(answers, function (answerText) {
                                order++;
                                var isCorrect = false;
                                if (answerText.substring(0, 1) === "~") {
                                    answerText = answerText.substring(1);
                                    isCorrect = true;
                                }
                                var answerFeedback = "";
                                var feedbackIndex = answerText.indexOf("|");
                                if (feedbackIndex > -1) {
                                    answerFeedback = answerText.substring(feedbackIndex + 1).trim();
                                    answerText = answerText.substring(0, feedbackIndex).trim();
                                }
                                var random = _.findIndex(vm.model.nonRandomAnswers, function (item) {
                                    return answerText.toLowerCase() === item.toLowerCase();
                                }) === -1;
                                var answer = { order: order, correct: isCorrect, answer: answerText, feedback: answerFeedback, randomOrder: random, enabled: true, editable: true };
                                newAnswers.push(answer);
                            });
                            var question = splits.join("\n\n");
                            var questionFeedback = "";
                            var questionFeedbackIndex = question.indexOf("|");
                            if (questionFeedbackIndex > -1) {
                                questionFeedback = question.substring(questionFeedbackIndex + 1).trim();
                                question = question.substring(0, questionFeedbackIndex).trim();
                            }
                            vm.model.question.question = question;
                            vm.model.question.feedback = questionFeedback;
                            vm.model.question.examQuestionAnswers = newAnswers;
                        }
                        vm.noneSelected = vm.checkNoneSelected();
                        vm.updateMultipleCorrect();
                    }
                });
            };
            vm.uploadQuestionFiles = function () {
                if (vm.questionFiles && vm.questionFiles.length) {
                    vm.questionFilesUpload = Upload.upload({
                        url: "api/exams/" + vm.number + "/questions/" + vm.questionNumber + "/files",
                        data: { files: vm.questionFiles }
                    });
                    vm.questionFilesUpload.then(function (response) {
                        $timeout(function () {
                            vm.model.questionFiles = _.union(vm.model.questionFiles, response.data);
                            vm.hasReferenceDocuments = true;
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.questionFilesProgress = 0;
                            $scope.$apply();
                        }, 300);
                    }, function (error) {
                        if (error.status > 0) {
                            messageService.error(error);
                        }
                        vm.questionFilesProgress = 0;
                    }, function (evt) {
                        vm.questionFilesProgress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.uploadImageFile = function () {
                if (vm.imageFile) {
                    vm.imageFileUpload = Upload.upload({
                        url: "api/exams/" + vm.number + "/questions/" + vm.questionNumber + "/uploadImage",
                        data: { file: vm.imageFile }
                    });
                    vm.imageFileUpload.then(function (response) {
                        $timeout(function () {
                            vm.model.questionHeaderImageUrl = response.data;
                            vm.hasQuestionHeaderImage = true;
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.imageFileProgress = 0;
                            $scope.$apply();
                        }, 300);
                    }, function (error) {
                        if (error.status > 0) {
                            messageService.error(error);
                        }
                        vm.imageFileProgress = 0;
                    }, function (evt) {
                        vm.imageFileProgress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.validateSameName = function (file) {
                if (_.some(vm.model.questionFiles, { fileName: file.name }))
                    return "sameName";
                else
                    return true;
            };
            vm.deleteFile = function (id) {
                var modal = $uibModal.open({
                    templateUrl: "deleteExamQuestionFileConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    examQuestionFilesResource.delete({ id: id }, function () {
                        vm.model.questionFiles = _.without(vm.model.questionFiles, _.find(vm.model.questionFiles, { id: id }));
                        vm.hasReferenceDocuments = vm.model.questionFiles !== null && vm.model.questionFiles.length > 0;
                        vm.invalidFiles = [];
                        messageService.success("common.fileDeleted");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.removeImage = function () {
                var modal = $uibModal.open({
                    templateUrl: "removeExamQuestionHeaderImageConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    examQuestionResource.removeExamQuestionHeaderImage({ number: vm.number, questionNumber: vm.questionNumber }, {}, function () {
                        vm.model.questionHeaderImageUrl = null;
                        vm.hasQuestionHeaderImage = false;
                        messageService.success("common.imageRemoved");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.preview = function (value) {
                $rootScope.showPageLoader = true;
                $timeout(function () {
                    frameworkService.data.hideAdminMenu = value;
                    $rootScope.$broadcast("hideAdminMenu:updated");
                    vm.previewMode = value;
                    $timeout(function () {
                        $rootScope.showPageLoader = false;
                    }, 400);
                }, 300);
            };
        }
    });
}());
